module.exports = __webpack_public_path__ + "img/chapter7finish.0211d812.jpg";